import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { CheckCircle2, X } from "lucide-react";

// V1.56.1 · Alerta en el panel cuando un alumno confirma y envía
// todos sus documentos a Natur (packs completados sin revisar).

const timeAgo = (iso) => {
  if (!iso) return "";
  const mins = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (mins < 60) return `hace ${mins} min`;
  const h = Math.round(mins / 60);
  if (h < 48) return `hace ${h} h`;
  return `hace ${Math.round(h / 24)} días`;
};

export default function DocBundleAlerts() {
  const [alerts, setAlerts] = useState([]);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/doc-bundles/completed-alerts");
      setAlerts(data || []);
    } catch { /* silencioso */ }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load]);

  const ack = async (id) => {
    setAlerts((a) => a.filter((x) => x.id !== id));
    try { await api.post(`/doc-bundles/${id}/ack`); } catch { load(); }
  };

  if (alerts.length === 0) return null;

  return (
    <div className="rounded-2xl border-2 border-emerald-300 bg-emerald-50 p-3 space-y-2" data-testid="doc-bundle-alerts">
      <div className="flex items-center gap-2 text-emerald-800">
        <CheckCircle2 className="h-4 w-4" />
        <span className="text-xs font-bold uppercase tracking-wider">Documentos recibidos · packs enviados por alumnos</span>
      </div>
      {alerts.map((a) => (
        <div key={a.id} className="flex items-start gap-2 rounded-xl bg-white border border-emerald-200 px-3 py-2" data-testid={`bundle-alert-${a.id}`}>
          <div className="min-w-0 flex-1 text-sm">
            <span className="font-semibold">{a.student_name}</span>{" "}
            ha confirmado y enviado {a.status === "completed" ? "todos sus documentos" : "sus documentos"} a Natur
            <span className="text-neutral-400 text-xs ml-1">{timeAgo(a.finished_at)}</span>
            {a.missing?.length > 0 && (
              <div className="text-xs text-amber-700 mt-0.5">
                ⚠ Quedó pendiente: {a.missing.join(", ")}
              </div>
            )}
          </div>
          <button
            type="button"
            onClick={() => ack(a.id)}
            data-testid={`bundle-alert-ack-${a.id}`}
            title="Marcar como visto"
            className="shrink-0 inline-flex items-center gap-1 h-7 px-2 rounded-lg text-[11px] font-semibold bg-emerald-600 hover:bg-emerald-700 text-white transition-colors"
          >
            <X className="h-3 w-3" /> Visto
          </button>
        </div>
      ))}
    </div>
  );
}
